import React from 'react'
import firebase from './../../config/fbConfig.js'
import { Link } from 'react-router-dom'
import options from './../assets/3dots.png'
import './extraOptions.css';
import noProfile from './../assets/noprofile.png'

const db = firebase.firestore();

function ExtraOptions(props) {

	// Showing the extraOptions element with fadeIn
	let showExtraOptions = (e) => {
		if (e.relatedTarget.className!="blankSpace") e.target.parentNode.nextSibling.classList.add("fadeIn");

		// If I dont do the next line and try to enter extra options from blank space so it won't work. so this line is necessary
		if (e.target.parentNode.nextSibling.nextSibling.className=="blankSpace") e.target.parentNode.nextSibling.nextSibling.hidden = false;
	}

	// Hiding the extraOptions element
	let hideExtraOptions = (e) => {	
		if (e.target.className=='extraOptions fadeIn' && e.relatedTarget.className!="option" && e.relatedTarget.className!="arrowRight" || e.target.className=="extraOptions fadeIn" && e.relatedTarget.tagName == "IMG")  {	
			// e.target.hidden = true;
			e.target.classList.remove("fadeIn");
			// If I dont do the next line and try to enter extra options from blank space so it won't work. so this line is necessary, hiding "blankSpace"
			e.target.nextSibling.hidden = true;
			console.log('1st case')
						
		}
		if (e.target.tagName=='IMG' && e.relatedTarget.className=="frame" || e.target.tagName=="IMG" && e.relatedTarget.tagName=="UL" || e.target.tagName=="IMG" && e.relatedTarget.className=="specificPost" || e.target.alt=="options" && e.relatedTarget.alt=="Post" || e.target.tagName=="IMG" && e.relatedTarget.className=="wrapperIMG") {
			e.target.parentNode.nextSibling.classList.remove("fadeIn");
			// If I dont do the next line and try to enter extra options from blank space so it won't work. so this line is necessary, hiding "blankSpace"
			e.target.parentNode.nextSibling.nextSibling.hidden = true;
			console.log('2nd case')
			
		}
		if (e.target.className=="option" && e.relatedTarget.className=="frame" || e.target.className=="option" && e.relatedTarget.tagName=="IMG" || e.target.className=="option" && e.relatedTarget.className=="wrapperIMG" ) {
			e.target.parentNode.classList.remove("fadeIn");
			// If I dont do the next line and try to enter extra options from blank space so it won't work. so this line is necessary, hiding "blankSpace"
			e.target.parentNode.nextSibling.hidden = true;
			console.log('3rd case')
		}
	}

	let showLikesList = (likesLength, e) => {
		if (!props.isPhone.current) {
			// The first value in the array is the number of likes, the 2nd is nickname+picture of the user who did the like. so if it's bigger than 1 = someone liked this post
			if (likesLength>1) {
				document.body.style.overflow = 'hidden';
				e.target.parentNode.nextSibling.nextSibling.hidden = false;
			} else {
				// What happens in case there's no likes in this post
				e.target.parentNode.classList.remove("fadeIn");
				alert('No likes for this post.. You saw 0 there come on')
			}
		} else { // If this is a phone so
			e.target.parentNode.nextSibling.classList.remove('fadeIn');
			if (likesLength>1) {
				document.body.style.overflow = 'hidden';
				e.target.parentNode.nextSibling.nextSibling.nextSibling.hidden = false;
			} else {
				// What happens in case there's no likes in this post		
				alert('No likes for this post.. You saw 0 there come on')
			}
		}
	}
	let closeLikesList = (e) => {
		e.target.parentNode.parentNode.hidden = true;
		if (props.album==null) document.body.style.overflow = 'visible';
	}

	let RemoveMyPost = (e) => {
		// In case this component was called from feed, so props.feed isn't null.
		if (props.feed!=null) {
			const specificPost = e.target.parentNode.parentNode.parentNode.parentNode.dataset.time;
			// Finding the specific index for this post, to update this later in the UI with setFeed
			let index = props.feed.findIndex(i => i.timestamp === specificPost);

			if (window.confirm("Are you sure you want to remove this post?")) {
				db.collection("feed").doc(specificPost).delete().then(function() {
				    db.collection("album").doc(props.user.uid).collection("album").doc(specificPost).delete().then(function() {
					    alert("Successfully deleted!");
						    props.feed.splice(index, 1);
							props.setFeed(props.feed);
							props.forceUpdate();
					});  
				}).catch(function(error) {
				    alert("There was an error: " + error)
				});			
			}	
		} else {
			const specificPost = e.target.parentNode.parentNode.parentNode.parentNode.dataset.id;
			let index = props.album.findIndex(i => i.timestamp === specificPost);

			if (window.confirm("Are you sure you want to remove this post?")) {
				db.collection("feed").doc(specificPost).delete().then(function() {
				    db.collection("album").doc(props.user.uid).collection("album").doc(specificPost).delete().then(function() {
					    alert("Successfully deleted!");
					    	props.album.splice(index, 1);
							props.setAlbum(props.album);
							props.forceUpdate();

							let albumLength = props.album.length;
							if (albumLength<12) {
								for (let i=1; i<=(12-albumLength); i++) {
									props.missingAlbum.push("")
								}
								props.setMissingAlbum(props.missingAlbum);
								props.forceUpdate();
							}
							document.body.style.overflow = 'visible';
					});  
				}).catch(function(error) {
				    alert("There was an error: " + error)
				});			
			}
		}
		
		
	}
	
	return (
		<div onMouseOut={hideExtraOptions}>

				<div className="backOptions" onMouseEnter={showExtraOptions}>
							<img src={options} alt="options"/>
						</div>
						
						<div className="extraOptions">
							<div className="arrowRight"></div>
							{props.isPhone.current ? <div className="option" onMouseEnter={() => showLikesList(props.likesLength, window.event)}>Show likes list</div> :
							<div className="option" onClick={() => showLikesList(props.likesLength, window.event)}>Show likes list</div>}
							
							{(props.user!=null && props.userID==props.user.uid) &&
							<React.Fragment>
								<hr/>
								<div className="option" onClick={() => window.alert(`This feature isn't available yet.`)}>Edit Post</div>
								<hr/>
								<div className="option" onClick={RemoveMyPost}>Remove Post</div>
							</React.Fragment>
							}
							
							{(props.user!=null && props.userID!=props.user.uid) && <React.Fragment> <hr/> <div className="option" onClick={() => window.alert('Successfully reported. Thank you for your care.')}>Report Post</div> </React.Fragment>}
						</div>

						<div className="blankSpace" hidden></div>
						
						<div className="LikesByPost" hidden>
								<ul> 
									<div className="closeButton" onClick={closeLikesList}>[X]</div>
									{props.postLikes!=[0] &&  props.postLikes.slice(1).map((like, index) => 

									<li key={index}>
										{like.profilePic!=false ? <img src={like.profilePic} alt="Profile Pic"/> : <img src={noProfile} alt="Profile Pic"/>}
										<Link to={'/profile/' + like.userID}><span className="nickname">{like.nickname}</span></Link>
									</li>

									)}
								</ul>
		
				</div>


		</div>
	)
}

export default ExtraOptions